import { RouteNames } from "../types/names";
import type { AppRouteRecordRaw } from "../types/types";
import { guestGuard } from "../utils/guards";

const authRoutes: AppRouteRecordRaw[] = [
  {
    path: "/auth",
    name: RouteNames.LOGIN,
    component: () => import("@/pages/Auth/LoginPage.vue"),
    meta: { title: "Login", layout: "auth", requiresAuth: false, showInMenu: false },
    beforeEnter: guestGuard,
  },
  {
    path: "/forgot-password",
    name: RouteNames.FORGET_PASSWORD,
    component: () => import("@/pages/Auth/ForgotPasswordPage.vue"),
    meta: { title: "Forgot Password", layout: "auth", requiresAuth: false, showInMenu: false },
    beforeEnter: guestGuard,
  },
  {
    path: "/reset-password",
    name: RouteNames.RESET_PASSWORD,
    component: () => import("@/pages/Auth/ResetPasswordPage.vue"),
    meta: { title: "Reset Password", layout: "auth", requiresAuth: false, showInMenu: false },
    beforeEnter: guestGuard,
  },
  {
    path: "/accept-invite",
    name: RouteNames.ACCEPT_INVITE,
    component: () => import("@/pages/Auth/AcceptInvitePage.vue"),
    meta: { title: "Accept Invite", layout: "auth", requiresAuth: false, showInMenu: false },
  },
];

export default authRoutes;
